import { PreguntasTipoEnum } from "@shared/enums";
import { DatosPreguntaImportador } from "..";
import { PREGUNTA_PADRE } from "../constantesImportador";
import { PreguntaImportador } from "../PreguntaImportador";

export class PreguntaMatrixSingleImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.MATRIX_SINGLE;
    }

    public testear(datos: DatosPreguntaImportador[], esUltima: boolean = false): boolean {
        const pasoTest = super.testear(datos, esUltima);
        const preguntaPadre = datos[PREGUNTA_PADRE];
        if (!preguntaPadre.random && preguntaPadre.tipoOpcion !== "R") {
            this.advertencias.push(
                `La pregunta ${datos[PREGUNTA_PADRE].idPregunta} no esta marcada como Random`
            );
        }
        return pasoTest;
    }
}
